import React from 'react';

import { Typography } from '@useblu/ocean-react';

import { FeedbackContainer } from '@/components/Template/Feedback';
import redirectIllustration from '@/assets/redirect.png';

import useRedirect from './Redirect.hook';

import * as S from './styles';

const Redirect: React.FC = () => {
  useRedirect();

  return (
    <FeedbackContainer>
      <S.Wrapper>
        <S.Image src={redirectIllustration} />
        <Typography variant="heading3">
          Aguarde enquanto o portador do cartão finaliza o pagamento...
        </Typography>
        <Typography variant="paragraph">
          Você será redirecionado em alguns minutos.
        </Typography>
      </S.Wrapper>
    </FeedbackContainer>
  );
};

export default Redirect;
